export default {"src":"/_next/static/media/websiteicon.67a9b474.svg","height":33,"width":32};